import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatProductModel } from 'src/app/model/cat-product.model';

@Injectable({
  providedIn: 'root'
})
export class CatProductService {
  private url: string;

  ////////////////
  constructor(
    private http: HttpClient
  ) {
    this.url = environment.services_url;
  }

  //
  getAll = () => {
    return this.http.get(`${this.url}/CatProduct/List`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  save = (userName: string, product: CatProductModel) => {
    return this.http.post(`${this.url}/CatProduct/savCatProduct/${userName}`, product)
      .pipe(
        map((resp: any) => resp)
      );
  }

  upload = (userName: string, file: File, replace: boolean) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userName', userName);
    formData.append('table', 'producto');
    formData.append('replace', String(replace));
    return this.http.post(`${this.url}/upload/save`, formData)
      .pipe(
        map((resp: any) => resp)
      );
  }

  downloadLayout = () => this.http.get(`${this.url}/CatProduct/DownloadLayout`, { responseType: 'blob' });
}
